import { authQueryKeys as e } from "../state/useAuthQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { authApi as r } from "@maat/api-main";
//#region src/queries/registration/useRegisterCompleteMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: r.registerComplete,
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.me() }), i.invalidateQueries({ queryKey: e.state() }), i.removeQueries({ queryKey: ["permission"] });
		}
	});
};
//#endregion
export { i as useRegisterCompleteMutation };
